import React, { useState, useEffect } from   'react';
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import { FaArrowAltCircleRight, FaEraser } from 'react-icons/fa';
import { useAuth } from '../../Auth/AuthContext';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';

export default function PpermisosPagRoles(){
    const { token, user } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [datos, setDatos] = useState([]);
    const [roles, setRoles] = useState([]);
    const [paginas, setPaginas] = useState([]);
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const [nombreComponente, setNombreComponente] = useState('Permisos pagina x roles');
    const [filters, setFilters] = useState({
        id: '',
        pagina: '',
        rol: '',
        creadoPor: '',
        fechaCreacion: '',
        modificadoPor: '',
        fechaModificacion: ''
    });
    const filteredDatos = datos.filter(row => {
        return (
            (!filters.id || row.id?.toString().includes(filters.id)) &&
            (!filters.pagina || row.ppaPaginanombre?.toLowerCase().includes(filters.pagina.toLowerCase())) &&
            (!filters.rol || row.rolRol?.toLowerCase().includes(filters.rol.toLowerCase())) &&
            (!filters.creadoPor || row.ppeCreadopor?.toLowerCase().includes(filters.creadoPor.toLowerCase())) &&
            (!filters.modificadoPor || row.ppeModificadopor?.toLowerCase().includes(filters.modificadoPor.toLowerCase()))
        );
    });
    useEffect(() => {
        fetchData();
        fetchRoles();
        fetchPaginas();
    }, []);
    const borrar = async (id) => {
        const url = `/parametros/eliminarppermisospagroles`;
        const obj = {
            id: id,
            usrId: user
        };
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            setSwalProps({
                show: true,
                title: 'Éxito',
                text: 'Registro eliminado correctamente',
                icon: 'success'
            });
            fetchData();
        } catch (error) {
            console.error('Error deleting data:', error);
            setSwalProps({
                show: true,
                title: 'Error',
                text: 'No se pudo eliminar el registro',
                icon: 'error'
            });
        } finally {
            setCargando(false);
        }
    };
    const fetchData = async () => {
        const url = '/parametros/listarppermisospagroles';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setDatos(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    const fetchRoles = async () => {
        const url = '/parametros/listarrolesactivo';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setRoles(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    const fetchPaginas = async () => {
        const url = '/parametros/listarppaginasactivo';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setPaginas(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    function Editar (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('usrId', user);
        setValue('Nuevo', false);
        setValue('ppePaginaid', row.ppePaginaid);
        setValue('ppeRolid', row.ppeRolid);
        setValue('ppePermisoaccess', row.ppePermisoaccess);
        setValue('ppePermisoinsert', row.ppePermisoinsert);
        setValue('ppePermisoupdate', row.ppePermisoupdate);
        setValue('ppePermisodelete', row.ppePermisodelete);
        setValue('ppePermisoview', row.ppePermisoview);
    }
    const Nuevo = () =>  {
        setValue('id', 0);
        setValue('usrId', user);
        setValue('Nuevo', true);
        setValue('ppePaginaid', 0);
        setValue('ppeRolid', 0);
        setValue('ppePermisoaccess', 0);
        setValue('ppePermisoinsert', 0);
        setValue('ppePermisoupdate', 0);
        setValue('ppePermisodelete', 0);
        setValue('ppePermisoview', 0);
        setMuestraFormulario(1);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardarppermisospagroles';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('usrId', user);
        setValue('Nuevo', true);
        setValue('ppePaginaid', 0);
        setValue('ppeRolid', 0);
        setValue('ppePermisoaccess', 0);
        setValue('ppePermisoinsert', 0);
        setValue('ppePermisoupdate', 0);
        setValue('ppePermisodelete', 0);
        setValue('ppePermisoview', 0);
        setMuestraFormulario(false);
    }
    return (
        <div className="content-wrapper">
            <SeccionPageHeader  
                title= {nombreComponente}
                idCabezaFamilia="1"
                url="/parametros"
                nombreurl="Parámetros"
                nombreform={nombreComponente}
            />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario {nombreComponente}</h3>
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    <input hidden {...register('id')}/>
                                    <input hidden {...register('Nuevo')}/>
                                    <input hidden {...register('usrId')}/>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="ppePaginaid">P&aacute;gina ID</label>
                                            <select id="ppePaginaid" className="form-control" {...register('ppePaginaid', { required: true })}>
                                                <option value="">Seleccione una p&aacute;gina</option>
                                                {paginas.map(pagina => (
                                                    <option key={pagina.id} value={pagina.id}>
                                                        {pagina.ppaNombrepag}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.ppePaginaid && <span className="text-danger">Este campo es obligatorio</span>}
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="ppeRolid">Rol ID</label>
                                            <select id="ppeRolid" className="form-control" {...register('ppeRolid', { required: true })}>
                                                <option value="">Seleccione un rol</option>
                                                {roles.map(rol => (
                                                    <option key={rol.id} value={rol.id}>
                                                        {rol.rolRol}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.ppeRolid && <span className="text-danger">Este campo es obligatorio</span>}
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="ppePermisoaccess">Permiso Access</label>
                                            <select id="ppePermisoaccess" className="form-control" {...register('ppePermisoaccess', { required: true })}>
                                                <option value="">Seleccione</option>
                                                <option value="1">S&iacute;</option>
                                                <option value="0">No</option>
                                            </select>
                                            {errors.ppePermisoaccess && <span className="text-danger">Este campo es obligatorio</span>}
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="ppePermisoinsert">Permiso Insert</label>
                                            <select id="ppePermisoinsert" className="form-control" {...register('ppePermisoinsert', { required: true })}>
                                                <option value="">Seleccione</option>
                                                <option value="1">S&iacute;</option>
                                                <option value="0">No</option>
                                            </select>
                                            {errors.ppePermisoinsert && <span className="text-danger">Este campo es obligatorio</span>}
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="ppePermisoupdate">Permiso Update</label>
                                            <select id="ppePermisoupdate" className="form-control" {...register('ppePermisoupdate', { required: true })}>
                                                <option value="">Seleccione</option>
                                                <option value="1">S&iacute;</option>
                                                <option value="0">No</option>
                                            </select>
                                            {errors.ppePermisoupdate && <span className="text-danger">Este campo es obligatorio</span>}
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="ppePermisodelete">Permiso Delete</label>
                                            <select id="ppePermisodelete" className="form-control" {...register('ppePermisodelete', { required: true })}>
                                                <option value="">Seleccione</option>
                                                <option value="1">S&iacute;</option>
                                                <option value="0">No</option>
                                            </select>
                                            {errors.ppePermisodelete && <span className="text-danger">Este campo es obligatorio</span>}
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="ppePermisoview">Permiso View</label>
                                            <select id="ppePermisoview" className="form-control" {...register('ppePermisoview', { required: true })}>
                                                <option value="">Seleccione</option>
                                                <option value="1">S&iacute;</option>
                                                <option value="0">No</option>
                                            </select>
                                            {errors.ppePermisoview && <span className="text-danger">Este campo es obligatorio</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <div className='row'>
                                    <div className='col-md-2'>
                                        <button type="button" className='form-control' onClick={Nuevo}>Nuevo</button>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <h5>{`Lista de ${nombreComponente}`}</h5>
                                    <table className="table table-bordered table-hover table-sm">
                                        <thead>
                                            <tr>
                                                <th>Acciones</th>
                                                <th>Id</th>
                                                <th>Pagina</th>
                                                <th>Rol</th>
                                                <th>Permiso Access</th>
                                                <th>Permiso Insert</th>
                                                <th>Permiso Update</th>
                                                <th>Permiso Delete</th>
                                                <th>Permiso View</th>
                                                <th>Creado Por</th>
                                                <th>Fecha Creación</th>
                                                <th>Modificado Por</th>
                                                <th>Fecha Modificación</th>
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <th>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Filtrar"
                                                        value={filters.id}
                                                        onChange={e => setFilters(f => ({ ...f, id: e.target.value }))}
                                                    />
                                                </th>
                                                <th>
                                                    <select
                                                        className="form-control form-control-sm"
                                                        value={filters.pagina}
                                                        onChange={e => setFilters(f => ({ ...f, pagina: e.target.value }))}
                                                    >
                                                        <option value="">Todas</option>
                                                        {paginas.map(p => (
                                                            <option key={p.id} value={p.ppaNombrepag}>{p.ppaNombrepag}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        className="form-control form-control-sm"
                                                        value={filters.rol}
                                                        onChange={e => setFilters(f => ({ ...f, rol: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {roles.map(r => (
                                                            <option key={r.id} value={r.rolRol}>{r.rolRol}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Filtrar"
                                                        value={filters.creadoPor}
                                                        onChange={e => setFilters(f => ({ ...f, creadoPor: e.target.value }))}
                                                    />
                                                </th>
                                                <th></th>
                                                <th>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Filtrar"
                                                        value={filters.modificadoPor}
                                                        onChange={e => setFilters(f => ({ ...f, modificadoPor: e.target.value }))}
                                                    />
                                                </th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Cargando ? (
                                                <tr>
                                                    <td colSpan={13} className="text-center">Cargando...</td>
                                                </tr>
                                            ) : filteredDatos.length === 0 ? (
                                                <tr>
                                                    <td colSpan={13} className="text-center">No hay datos para mostrar</td>
                                                </tr>
                                            ) : (
                                                filteredDatos.map((row, idx) => (
                                                    <tr key={row.id || idx}>
                                                        <td>
                                                            <div className="btn-group">
                                                                <button type="button" className="btn btn-info" onClick={() => Editar(row)} 
                                                                    data-tooltip-id='tooltiparriba'
                                                                    data-tooltip-content="Editar">
                                                                    <FaArrowAltCircleRight/>
                                                                </button>
                                                            </div>
                                                            <div className="btn-group">
                                                                <button type="button" className="btn btn-danger" onClick={() => borrar(row.id)} 
                                                                    data-tooltip-id='tooltiparriba'
                                                                    data-tooltip-content="Eliminar">
                                                                    <FaEraser/>
                                                                </button>
                                                            </div>
                                                        </td>
                                                        <td>{row.id}</td>
                                                        <td>{row.ppaPaginanombre}</td>
                                                        <td>{row.rolRol}</td>
                                                        <td>{row.ppePermisoaccess}</td>
                                                        <td>{row.ppePermisoinsert}</td>
                                                        <td>{row.ppePermisoupdate}</td>
                                                        <td>{row.ppePermisodelete}</td>
                                                        <td>{row.ppePermisoview}</td>
                                                        <td>{row.ppeCreadopor}</td>
                                                        <td>{row.ppeFechacreacion ? new Date(row.ppeFechacreacion).toLocaleDateString() : ''}</td>
                                                        <td>{row.ppeModificadopor}</td>
                                                        <td>{row.ppeFechamodificacion ? new Date(row.ppeFechamodificacion).toLocaleDateString() : ''}</td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}